module.exports = __webpack_public_path__ + "img/appstore_es.ebdcadff.svg";